import React from 'react';
import { Widget as WidgetWrapper, WidgetHeader, WidgetTitle, WidgetDescription, WidgetBody } from '@/components/custom/widget';

function Widget(props) {
  const { title = 'Widget title', description, children } = props;

  return (
    <WidgetWrapper>
      <WidgetHeader>
        <WidgetTitle>{title}</WidgetTitle>
        {description && <WidgetDescription>{description}</WidgetDescription>}
      </WidgetHeader>
      <WidgetBody>{children}</WidgetBody>
    </WidgetWrapper>
  );
}

export default Widget;
